'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002416 from "./presto.-Register-Page-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$15() {
  this.bt5 = null;
  this.bsX = null;
  this.bsY = false;
  this.bt6 = null;
  this.bt7 = false;
  this.bta = null;
  this.bt3 = null;
  this.bt4 = false;
  this.bsZ = null;
  this.bt0 = false;
  this.bt1 = null;
  this.bt2 = false;
  this.bt8 = false;
  this.bt9 = false;
  this.bt5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bta = "MorbidUserDetails";
}
export { $c_Lpresto_RegisterPageView$$anon$15 as $c_Lpresto_RegisterPageView$$anon$15 };
$p = $c_Lpresto_RegisterPageView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$15;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$15() {
}
export { $h_Lpresto_RegisterPageView$$anon$15 as $h_Lpresto_RegisterPageView$$anon$15 };
$h_Lpresto_RegisterPageView$$anon$15.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bt5;
});
$p.M = (function() {
  if ((!this.bsY)) {
    this.bsX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bsY = true;
  }
  return this.bsX;
});
$p.O = (function() {
  if ((!this.bt7)) {
    this.bt6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bt7 = true;
  }
  return this.bt6;
});
$p.E = (function() {
  return this.bta;
});
$p.t = (function() {
  if ((!this.bt4)) {
    this.bt3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bt4 = true;
  }
  return this.bt3;
});
$p.N = (function() {
  if ((!this.bt0)) {
    this.bsZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bt0 = true;
  }
  return this.bsZ;
});
$p.Q = (function() {
  if ((!this.bt2)) {
    this.bt1 = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002416.$c_Lpresto_RegisterPageView$$anon$16();
    this.bt2 = true;
  }
  return this.bt1;
});
$p.v = (function() {
  if ((!this.bt9)) {
    this.bt8 = false;
    this.bt9 = true;
  }
  return this.bt8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee113) => ((p) => \u03b4scrutinee113.Gp(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_RegisterPageView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$15, "presto.RegisterPageView$$anon$15", ({
  Qj: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$15 as $d_Lpresto_RegisterPageView$$anon$15 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$15.js.map
